import { render, staticRenderFns } from "./ModelsList.vue?vue&type=template&id=54ee33c0"
import script from "./ModelsList.vue?vue&type=script&lang=js"
export * from "./ModelsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports